import * as React from 'react';
import { ContextualMenu, Dialog, DialogType, IconButton, TextField } from '@fluentui/react';
import { ArtikelDetail } from 'api/artikelDetail';
import { mergeStyleSets } from '@fluentui/react/lib/Styling';
import { artikelGruppenByNrSelector } from 'store/lookups/selector';
import { useSelector } from 'react-redux';
import { useArtikel } from 'api/artikel';
import { ArtikelDetailSearch } from './ArtikelDetailSearch';

const styles = mergeStyleSets({
    inputContainer: {
        position: 'relative',
    },
});

interface ArtikelSearchProps {
    artikelGruppeNr?: number;
    artikelNr?: string;
    disabled?: boolean;
    onChange: (newArtikelDetail: ArtikelDetail | null) => void;
}

export const ArtikelDetailSelect: React.FC<ArtikelSearchProps> = ({
    artikelGruppeNr,
    artikelNr,
    disabled = false,
    onChange,
}) => {
    const artikelGruppenByNr = useSelector(artikelGruppenByNrSelector);

    const [isOpen, setIsOpen] = React.useState(false);

    const selectedArtikel = useArtikel({ artikelNr }, { enabled: !!artikelNr });

    const artikelGruppe = artikelGruppeNr ? artikelGruppenByNr[artikelGruppeNr] : null;

    let label = '';
    if (artikelGruppe?.text) {
        label += artikelGruppe?.text;
    }

    if (artikelNr) {
        label += ' | ' + artikelNr;
    }

    if (selectedArtikel.data?.text) {
        label += ' | ' + selectedArtikel.data?.text;
    }

    return (
        <div className={styles.inputContainer}>
            <TextField
                styles={{ field: { cursor: disabled ? 'default' : 'pointer' } }}
                label="Artikel"
                value={label}
                disabled={disabled}
                onChange={() => {}}
                onClick={() => {
                    if (!disabled) {
                        setIsOpen(true);
                    }
                }}
            />
            <IconButton
                onClick={() => {
                    onChange(null);
                }}
                iconProps={{ iconName: 'Clear', style: { fontSize: 10 } }}
                style={{ position: 'absolute', right: 8, top: 36, width: 18, height: 18 }}
            />
            {isOpen && (
                <Dialog
                    hidden={false}
                    title="Artikelauswahl"
                    dialogContentProps={{
                        type: DialogType.normal,
                    }}
                    modalProps={{
                        isBlocking: true,
                        dragOptions: {
                            moveMenuItemText: 'Move',
                            closeMenuItemText: 'Close',
                            menu: ContextualMenu,
                        },
                    }}
                    minWidth="95%"
                    maxWidth="95%"
                    onDismiss={() => {
                        setIsOpen(false);
                    }}
                >
                    <ArtikelDetailSearch
                        parentView="ArtikelDetailSelect"
                        insideDialog
                        selectedArtikelGruppeNr={artikelGruppeNr}
                        selectedArtikelNr={artikelNr}
                        onClick={(artikelDetail) => {
                            setIsOpen(false);
                            onChange(artikelDetail);
                        }}
                    />
                </Dialog>
            )}
        </div>
    );
};
